(function () {
  'use strict';

  /* Le meme <script src> est re-injecte et re-execute a chaque
     section:load de l'editeur de theme : sans ce verrou, les listeners
     document seraient dupliques a chaque rechargement. */
  if (window.VD_PRODUIT_INIT) return;
  window.VD_PRODUIT_INIT = true;

  var instances = [];

  function poserLibelle(bouton, prix) {
    var libelle = bouton.getAttribute('data-libelle-ajout') || '';
    var court = bouton.getAttribute('data-libelle-court');
    bouton.disabled = false;
    bouton.textContent = '';
    if (court) {
      var libelleComplet = document.createElement('span');
      libelleComplet.className = 'produit__achat-libelle';
      var long = document.createElement('span');
      long.className = 'produit__achat-long';
      long.textContent = libelle;
      var bref = document.createElement('span');
      bref.className = 'produit__achat-court';
      bref.textContent = court;
      libelleComplet.append(long, bref);
      if (prix) libelleComplet.append(' pour ' + prix);
      bouton.append(libelleComplet);
    } else {
      bouton.append(prix ? libelle + ' pour ' + prix : libelle);
    }
    bouton.dataset.vdLibelleRepos = bouton.innerHTML;
  }

  function creerFiche(racine) {
    var form = racine.querySelector('[data-vd-form-panier]');
    var boutons = Array.prototype.slice.call(
      racine.querySelectorAll('[data-vd-bouton-achat]')
    );
    var meta = racine.querySelector('[data-vd-sticky-meta]');
    var cta = racine.querySelector('[data-vd-cta]');
    var barre = racine.querySelector('[data-vd-sticky]');
    var montant = racine.querySelector('[data-vd-prix-montant]');
    var detail = racine.querySelector('[data-vd-prix-detail]');
    var quantite = racine.querySelector('[data-vd-quantite]');
    var observateur = null;
    var observateurPied = null;
    var ctaHorsEcran = false;
    var piedVisible = false;

    /* Changement de variante : les radios desactivees (variantes
       epuisees) ne declenchent jamais change, toute variante choisie
       est donc disponible. Prix et libelles sont deja formates par
       Liquid dans les data-attributs : aucune requete reseau. */
    function surChangement(evt) {
      var radio = evt.target;
      if (radio.name !== 'id' || radio.type !== 'radio' || !radio.checked) return;
      var prix = radio.getAttribute('data-prix') || '';
      boutons.forEach(function (bouton) {
        poserLibelle(bouton, prix);
      });
      if (montant && prix) montant.textContent = prix;
      if (detail) {
        var option = radio.closest('label');
        var source = option ? option.querySelector('.prix-canette') : null;
        detail.innerHTML = source ? source.outerHTML : '';
      }
      if (meta) meta.textContent = radio.getAttribute('data-titre') || '';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    }

    function surPas(evt) {
      var bouton = evt.target.closest('[data-vd-quantite-pas]');
      if (!bouton) return;
      var champ = quantite.querySelector('input');
      if (!champ) return;
      var min = Number(champ.min) || 1;
      var max = Number(champ.max) || 99;
      var valeur = Math.round(Number(champ.value)) || min;
      var pas = Number(bouton.getAttribute('data-vd-quantite-pas')) || 0;
      champ.value = String(Math.min(max, Math.max(min, valeur + pas)));
    }

    function majBarre() {
      barre.classList.toggle('est-visible', ctaHorsEcran && !piedVisible);
    }

    if (form) form.addEventListener('change', surChangement);
    if (quantite) quantite.addEventListener('click', surPas);

    if (barre && cta) {
      if ('IntersectionObserver' in window) {
        observateur = new IntersectionObserver(
          function (entrees) {
            ctaHorsEcran = !entrees[entrees.length - 1].isIntersecting;
            majBarre();
          },
          { rootMargin: '-90px 0px 0px 0px' }
        );
        observateur.observe(cta);
        var pied = document.querySelector('.pied');
        if (pied) {
          observateurPied = new IntersectionObserver(function (entrees) {
            piedVisible = entrees[entrees.length - 1].isIntersecting;
            majBarre();
          });
          observateurPied.observe(pied);
        }
      } else {
        barre.classList.add('est-visible');
      }
    }

    return {
      racine: racine,
      detruire: function () {
        if (observateur) {
          observateur.disconnect();
          observateur = null;
        }
        if (observateurPied) {
          observateurPied.disconnect();
          observateurPied = null;
        }
        if (form) form.removeEventListener('change', surChangement);
        if (quantite) quantite.removeEventListener('click', surPas);
        delete racine.dataset.vdProduitActif;
      }
    };
  }

  function initDans(perimetre) {
    var racines = perimetre.querySelectorAll('[data-vd-produit]');
    Array.prototype.forEach.call(racines, function (racine) {
      if (racine.dataset.vdProduitActif) return;
      racine.dataset.vdProduitActif = 'true';
      instances.push(creerFiche(racine));
    });
  }

  function detruireDans(perimetre) {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (perimetre.contains(instances[i].racine)) {
        instances[i].detruire();
        instances.splice(i, 1);
      }
    }
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initDans(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    detruireDans(evt.target);
  });

  initDans(document);
})();
